export default "__VITE_ASSET__DegK0jKx__"